import React from "react";
import { Card, CardContent, Typography, Button } from "@mui/material";
import { Battery20 as BatteryIcon } from "@mui/icons-material";

const EmptyState = ({ status, onClearFilters }) => {
  const getMessage = () => {
    switch (status) {
      case "in-transit":
        return "No batteries in transit";
      case "received":
        return "No received batteries found";
      case "cancelled":
        return "No cancelled movements found";
      case "rejected":
        return "No rejected movements found";
      default:
        return "No movements found";
    }
  };

  return (
    <Card>
      <CardContent sx={{ textAlign: "center", py: 6 }}>
        <BatteryIcon sx={{ fontSize: 48, color: "grey.400", mb: 2 }} />
        <Typography variant="h6" color="textSecondary" gutterBottom>
          {getMessage()}
        </Typography>
        <Button onClick={onClearFilters} color="primary" sx={{ mt: 1 }}>
          Clear filters
        </Button>
      </CardContent>
    </Card>
  );
};

export default EmptyState;
